import { FormBuilder } from "components/form/FormBuilder";
import React from "react";
import { SerializedError } from "@reduxjs/toolkit";

import { i18nService } from "services";
import { IAPIState, INewsletterSubmitData, MessageTheme } from "types";
import { FormRequired, Message } from "components";

import { NewsletterFormContainerProps } from "../containers";
import { makeSchema } from "./formSchema";

interface NewsletterFormProps extends NewsletterFormContainerProps {
  onSubmit: (data: INewsletterSubmitData) => void;
  status: IAPIState;
  clearState: () => void;
  error?: SerializedError | string | null;
  successMessage?: string | null;
}

export const NewsletterForm: React.FC<NewsletterFormProps> = ({
  id,
  newsletters,
  onSubmit,
  status,
  clearState,
  error,
  successMessage,
}) => {
  return (
    <div className="newsletter-form">
      <p className="newsletter-form__required-guide">
        <FormRequired /> {i18nService.copy["form.requiredGuide"]}
      </p>

      <FormBuilder
        {...makeSchema(id, newsletters)}
        submitLabel={i18nService.copy["newsletter.subscribe"]}
        onFormSubmit={onSubmit}
        isSubmitting={status === IAPIState.pending}
        isSubmitted={status === IAPIState.succeeded}
        resetLabel={i18nService.copy["newsletter.subscribeNew"]}
        handleReset={clearState}
      />
      {error && <Message theme={MessageTheme.error}>{error}</Message>}
      {successMessage && (
        <Message theme={MessageTheme.success}>{successMessage}</Message>
      )}
    </div>
  );
};
